import React, { useCallback, useEffect } from "react";
import { Checkbox } from "@alm/flow-ds/components";
import { CommonPropertyProps } from "schemas/elements";
import { useTranslation } from "react-i18next";

type Props = Omit<CommonPropertyProps, "value"> & {
	value: boolean;
	tableNested?: boolean;
};

export default ({
	updateStore,
	field,
	required,
	value,
	desc,
	validation,
	elementIndex,
	id,
	tableNested,
}: Props) => {
	const { t } = useTranslation();
	const handleChange = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			updateStore({
				elementIndex,
				property: field,
				value: e.target.checked,
			});
		},
		[elementIndex, field, updateStore]
	);
	useEffect(() => {
		if (value === false && tableNested) {
			updateStore({
				elementIndex,
				property: field,
				value: true,
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	return (
		<Checkbox
			id={id}
			value={!!value as unknown as string}
			checked={value ? value : false}
			required={required}
			onChange={handleChange}
			label={
				desc === "text.isArray"
					? t(`formDesigner.properties.isArrayText`)
					: t(`formDesigner.properties.${field}`)
			}
			className="align-col"
			hint={
				field === "isArray" && desc !== "text.isArray"
					? t(`formDesigner.elements.${desc}`)
					: undefined
			}
			disabled={tableNested}
		/>
	);
};
